import { createSlice } from '@reduxjs/toolkit';

const pendingOrdersCreatedBySlice = createSlice({
  name: 'pendingOrdersCreatedBy',
  initialState: [],
  reducers: {
    setPendingOrdersCreatedBy: (state, { payload: { createdBy } }) => {
      return createdBy;
    }
  },
});

export const {
  setPendingOrdersCreatedBy
} = pendingOrdersCreatedBySlice.actions;

export default pendingOrdersCreatedBySlice.reducer;